export default "__VITE_ASSET__IjVqnIiH__"